import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { advanceParamCheck, requiredParamsCheck } from '../../utils';

export interface CreateBLEConnectionOption
  extends Partial<GeneralInvokeOption> {
  deviceId: string;
  timeout?: number;
  invalidParamObj?: '';
}

// 连接蓝牙低功耗设备
export function createBLEConnection(option: CreateBLEConnectionOption) {
  if (
    !requiredParamsCheck(
      { deviceId: option.deviceId },
      option,
      APINames.Native.CREATE_BLE_CONNECTION
    )
  ) {
    return option.invalidParamObj;
  }
  if (
    advanceParamCheck(
      APINames.Native.CREATE_BLE_CONNECTION,
      option,
      { deviceId: '', timeout: 0 },
      { timeout: { optional: true } }
    )
  ) {
    const fixedOption = Object.assign(
      {
        timeout: 30000
      },
      option
    );
    return MacleJSBridge.beforeInvoke(
      APINames.Native.CREATE_BLE_CONNECTION,
      fixedOption
    );
  }
  return option.invalidParamObj;
}
